<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>Identidade Consumidor</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding padding-horizontal">

    <div class="print-preview">

        <div #Card class="card-wrapper">

            <div class="card" [style.background-image]="CardFrontImage ? ('url(' + CardFrontImage + ')') : null">

                <div class="photo-box">
                    <img [src]="Data?.Image?.Path || '/assets/projects/img-default-profile.svg'" alt="" />
                </div>

                <div class="qr-box">
                    <qr-code [value]="Code" size="300" errorCorrectionLevel="Q" />
                </div>

                <div class="info-strip">
                    <span class="number">{{CardNumber}}</span>
                    <span class="name">{{Data?.Name}}</span>
                </div>

            </div>

            <span class="crop-line h top-left"></span>
            <span class="crop-line v top-left"></span>
            <span class="crop-line h top-right"></span>
            <span class="crop-line v top-right"></span>
            <span class="crop-line h bottom-left"></span>
            <span class="crop-line v bottom-left"></span>
            <span class="crop-line h bottom-right"></span>
            <span class="crop-line v bottom-right"></span>

        </div>

        <p class="print-note">Imprimir a Tamanho Real (100%) — sem ajustar à página.</p>

    </div>

    <div #Instructions>

        <div id="instructions">
            <h3 class="ion-padding-horizontal ion-text-center ion-padding-bottom">Instruções de Utilização
            </h3>

            <p>
                Para utilizar o seu cartão, apresente o <strong>QR Code</strong> ao
                comerciante ou, em alternativa, indique o
                <strong>número do cartão</strong>.<br />Após esta etapa, o comerciante poderá
                aceder aos seus dados para verificar a sua elegibilidade e os
                <strong>benefícios associados</strong> ao cartão.
            </p>
            <p>
                Recomendamos que <strong>descarregue e imprima este documento</strong> para
                ter consigo sempre que necessário.
            </p>
        </div>

    </div>

</ion-content>
<ion-footer>
    <ion-toolbar class="ion-padding-end">
        <ion-buttons slot="end">
            <ion-button fill="solid" color="primary" (click)="GeneratePdf($event)">Descarregar</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
